import React from "react";
import Image from "next/image";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

type Card = {
  id: string;
  image: string;
  title: string;
  description: string;
};

type CardsGridProps = {
  Cards: Card[];
  columns: number;
};

const CardsGrid: React.FC<CardsGridProps> = ({ Cards, columns }) => {
  return (
    <div
      className={cn("mt-8 grid gap-0", `grid-cols-${columns} sm:grid-cols-${columns}`)}
    >
      {Cards.map((card) => (
        <Card
          key={card.id}
          className="no-padding flex flex-col items-center space-y-0 border-none p-0 shadow-none"
        >
          <CardHeader className="flex flex-col items-center">
            <Image
              width={400}
              height={400}
              src={card.image}
              alt={card.title}
              className="mb-4"
            />
            <CardTitle className="text-center text-lg">{card.title}</CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col items-center">
            <CardDescription className="text-center text-sm text-gray-800">
              {card.description}
            </CardDescription>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default CardsGrid;
